<div class="status" [formGroup]="statuses">
  <div class="flex gap-3">
    <div class="radio">
      <p-radioButton
        name="status"
        value="1"
        formControlName="status"
        inputId="status_1"
      />
    </div>
    <div>
      <label for="status_1">In lavorazione</label>
      <p>
        La richiesta è stata ricevuta e in lavorazione.
      </p>
    </div>
  </div>
  <div class="flex gap-3">
    <div class="radio">
      <p-radioButton
        name="status"
        value="2"
        formControlName="status"
        inputId="status_2"
      />
    </div>
    <div>
      <label for="status_2">Evasa</label>
      <p>Il trasferimento fondi è stato completato.</p>
    </div>
  </div>
  <div class="flex gap-3">
    <div class="radio">
      <p-radioButton
        name="status"
        value="3"
        formControlName="status"
        inputId="status_3"
      />
    </div>
    <div>
      <label for="status_3">Annullata</label>
      <p>La richiesta di trasferimento fondi è rifiutata.</p>
    </div>
  </div>
</div>
<div class="modal-footer flex justify-content-end">
  <div>
    <p-button
      label="Salva"
      size="small"
      [outlined]="true"
      styleClass="px-6"
      (click)="save()"
    ></p-button>
  </div>
</div>